export interface NavigationGuardInput {
  target?: string | null;
  recentlyVisible: boolean;
  messageStreamActive: boolean;
  eventRunId?: string | null;
  currentRunId?: string | null;
}

export function shouldApplyNavigationDelta(input: NavigationGuardInput): boolean {
  if (!input.target) return false;
  if (input.recentlyVisible) return false;
  if (input.eventRunId && input.currentRunId && input.eventRunId !== input.currentRunId) {
    return false;
  }
  if (input.eventRunId && input.currentRunId && input.eventRunId === input.currentRunId) {
    return true;
  }
  return false;
}

export function isDuplicateNavigationTarget(
  lastTarget: string | null,
  lastAt: number,
  target: string,
  now: number,
  windowMs: number = 3000
): boolean {
  if (!lastTarget) return false;
  return lastTarget === target && now - lastAt < windowMs;
}
